import React from 'react';
import { Link } from 'react-router-dom';

import Card from '../../components/ui/Card';

export default function AuthShell({ title, subtitle, footer, children }) {
  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-white via-green-50 to-white">
      <header className="mx-auto w-full max-w-6xl px-6 py-6">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="h-10 w-10 flex-shrink-0 overflow-hidden">
            <img src="/atharva-logo.png" alt="Atharva logo" className="h-full w-full object-contain" />
          </div>
          <div className="flex flex-col leading-none">
            <span className="text-lg font-bold tracking-tight text-green-800">Atharva</span>
            <span className="text-[10px] font-medium uppercase tracking-widest text-gray-500">
              Sustainable Agritech
            </span>
          </div>
        </Link>
      </header>
      <main className="flex flex-1 items-center justify-center px-6 pb-16">
        <Card className="w-full max-w-md p-8">
          <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-gray-600">{subtitle}</p>}
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-gray-600">{footer}</div>}
        </Card>
      </main>
    </div>
  );
}
